import { privateApi, UpdatePhaseStrategy } from 'services';
import { CreatePhaseStrategy, PhaseStrategy } from './types';

const fetchPhaseStrategy = (phaseStrategyId: string): Promise<PhaseStrategy> =>
    privateApi.get<PhaseStrategy>(`phase-strategies/${phaseStrategyId}`);

const createPhaseStrategy = async (phaseStrategy: CreatePhaseStrategy): Promise<PhaseStrategy> =>
    privateApi.post<PhaseStrategy>('phase-strategies', phaseStrategy);

const updatePhaseStrategy = async (
    phaseStrategyId: string,
    phaseStrategy: UpdatePhaseStrategy,
): Promise<PhaseStrategy> => privateApi.put<PhaseStrategy>(`phase-strategies/${phaseStrategyId}`, phaseStrategy);

const deletePhaseStrategy = (phaseStrategyId: string): Promise<PhaseStrategy> =>
    privateApi.delete<PhaseStrategy>(`phase-strategies/${phaseStrategyId}`);

export const PhaseStrategyGateway = {
    fetchPhaseStrategy,
    createPhaseStrategy,
    updatePhaseStrategy,
    deletePhaseStrategy,
};
